import styled from '@emotion/styled'
import { FadeInUp } from 'app/components/Common/FadeInUp'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { useVocabularyData } from 'app/utils/vocabulary'
import React, { memo } from 'react'

import { Item, Props as ItemProps } from './Item'

export interface Props {
  items: ItemProps[]
  languageCode: string
}

export const BannerCTA = memo(function BannerCTA({
  items,
  languageCode,
}: Props) {
  if (items.length < 1) {
    return null
  }

  return (
    <Container>
      <Head>
        <FadeInUp>
          <Label>{useVocabularyData('banner-cta-label', languageCode)}</Label>
        </FadeInUp>
        <FadeInUp>
          <Title>{useVocabularyData('banner-cta-title', languageCode)}</Title>
        </FadeInUp>
      </Head>

      <Wrapper row wrap>
        {items.map((item, index) => (
          <Item key={index} {...item} />
        ))}
      </Wrapper>
    </Container>
  )
})

const Container = styled.section``

const Head = styled(FlexBox)`
  padding: 0 10.556vw;

  @media (max-width: 1199px) {
    padding: 0 1.875rem;
  }

  @media (max-width: 767px) {
    padding-right: 1.25rem;
    padding-left: 1.25rem;
  }
`

const Label = styled.div`
  color: ${({ theme }) => theme.colors.variants.secondaryLight};
  font-family: ${({ theme }) => theme.fontFamily.paragraph};
  font-size: 1.0625rem;
  font-weight: 500;
  line-height: 1.25rem;
  margin-bottom: 0.1875rem;
  text-transform: uppercase;

  @media (max-width: 1199px) {
    font-size: 1rem;
  }
`

const Title = styled.h2`
  color: ${({ theme }) => theme.colors.variants.neutralDark2};
  font-family: ${({ theme }) => theme.fontFamily.heading};
  font-size: 2.25rem;
  font-weight: 500;
  line-height: 2.875rem;
`

const Wrapper = styled(FlexBox)`
  margin: 1.25rem -1.875rem 0 0;
  padding: 0 10.556vw;
  &:before {
    content: '';
    width: 100%;
    height: 50%;
    background: ${({ theme }) => theme.colors.variants.neutralDark2};
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: -1;
  }

  @media (max-width: 1199px) {
    margin-right: -1.5rem;
    padding: 0 1.875rem;
  }

  @media (max-width: 1023px) {
    margin: 0.75rem 0 5.625rem;
    &:before {
      display: none;
    }
  }

  @media (max-width: 767px) {
    margin-bottom: 3.75rem;
    padding-right: 1.25rem;
    padding-left: 1.25rem;
  }
`
